import type { SelectNetPriceProps } from "~/domains/product/utils/productDescriptorUtils";
import type { RootState } from "~/app/store";
import type { PriceData } from "~/domains/pricing/types/PriceData";
import { selectProperAmountInCart } from "~/features/addToCart/redux/cartAmounts/cartAmountSelectors";
import { selectPriceScalingElement } from "~/utils/pricePicker";
import type { SalesData } from "~/features/salesCampaign/utils/salesCampaignUtils";

export const selectSalesPrice =
  ({ salesData, ...props }: SelectNetPriceProps & { salesData: SalesData | undefined }) =>
  (state: RootState): PriceData | undefined => {
    if (salesData?.price) {
      const cartQty = selectProperAmountInCart(props)(state);
      const totalQuantity = cartQty + (props.extraQuantity ?? 0);
      return selectPriceScalingElement(totalQuantity, salesData.price).price;
    }
  };
